import { SearchParameters } from "ofetch";
import {CartResponse, CatalogResponse} from "ecom-types";
import FetchFactory from "../factory";
import {OrderResponse} from "ecom-types/src/types/api/orders.types";

class CheckoutModule extends FetchFactory {
  /**
   * Get checkout cart
   *
   * @param params
   * @returns Promise
   */
  getCheckoutCart(params: {cart_unique_id: string}) {
    return this.fetch<CartResponse>(
      "GET",
      `/checkout/get-cart`,
      { params },
    );
  }
  /**
   * Get checkout cart
   *
   * @param params
   * @returns Promise
   */
  getCheckoutOrder(params: {cart_unique_id: string}) {
    return this.fetch<OrderResponse>(
        "GET",
        `/checkout/get-order`,
        { params },
    );
  }
}

export default CheckoutModule;
